export class LogTTEPengetahuan {
  id: number;
  pengetahuan_id: number;
  title: string;
  note: string;
  total: number;
  diproses: number;
  berhasil: number;
  gagal: number;
  jadwal_mulai: string;
  jadwal_selesai: string;
  created_at: string;
  updated_at: string;
  jumlah_data: number;

  constructor(
    id: number,
    pengetahuan_id: number,
    title: string,
    note: string,
    total: number,
    diproses: number,
    berhasil: number,
    gagal: number,
    jadwal_mulai: string,
    jadwal_selesai: string,
    created_at: string,
    updated_at: string,
    jumlah_data: number
  ) {
    this.id = id;
    this.pengetahuan_id = pengetahuan_id;
    this.title = title;
    this.note = note;
    this.total = total;
    this.diproses = diproses;
    this.berhasil = berhasil;
    this.gagal = gagal;
    this.jadwal_mulai = jadwal_mulai;
    this.jadwal_selesai = jadwal_selesai;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.jumlah_data = jumlah_data;
  }
}
